import React, { useEffect } from "react";
import "./App.css";
import "antd/dist/reset.css";
import { Route, Routes, Navigate } from "react-router-dom";
import PublicRoutes from "./router/public.routes";
import ProtectedRoutes from "./router/protected.routes";
import { useDispatch, useSelector } from "react-redux";
import * as loginActions from "./actions/login.action";
import * as roleActions from "./actions/role-org.action";
import {
  MENU_HOME,
  MENU_LOGIN,
  PIM_CREATE,
  PIM_NEW_RESIGN,
  PIM_EMP,
  PIM_ORG_CHART,
  PIM_TRAIN,
  PIM_EVA,
  PIM_RECRUI,
  PIM_PDREQ,
  PIM_ORG_FACTION,
  PIM_ORG_DEPARTMENT,
  PIM_ORG_TEAM,
  PIM_ORG_POSITION,
  // PIM_TRANSFER,
  PAGE_SETTING,
  PAGE_HOLIDAY,
  PAGE_CONTRACTS,
  EMP_PVD,
  EMP_EJIP,
  EMP_EJIP_DETAIL,
  EMP_MONTHLY_NEW,
  EMP_MONTHLY_HBD,
  EMP_MONTHLY_RESIGNS,
  EMP_MONTHLY_APPOINT,
  EMP_CHECK_LIST_RESIGN,
  EMP_CHECK_LIST_DETAIL_ST_1,
  EMP_CHECK_LIST_DETAIL_ST_3,
  EMP_CHECK_LIST_DETAIL_ST_4,
  EMP_CHECK_LIST_DETAIL_ST_5,
  EMP_EJIP_ALLMEMBER,
  EMP_CHECK_LIST_NEW,
  EMP_CHECK_LIST_RESIGN_PD,
  EMP_CHECK_LIST_RESIGN_IT,
  EMP_CONTRACT_FULLTIME_PDF,
  EMP_CONTRACT_SECRET_PDF,
  EMP_CONTRACT_PDPA_PDF,
  EMP_CONTRACT_COMPENSATION_SLIP_PDF,
  EMP_CONTRACT_NEW_EMP,
  EMP_EJIP_MEMBERBY_ROUND,
  EMP_TRANSFER,
  EMP_PVD_HISTORY,
  EMP_TRANSFER_ORG,
  EMP_TRANSFER_DETAIL,
  EMP_TRANSFER_ORG_DETAIL,
  EMP_TRANSFER_DETAIL_HISTORY,
  PAGE_MYPROFILE,
  PAGE_MYPROFILE_PRESONAL,
  PAGE_MYPROFILE_EMERGENCY,
  PAGE_MYPROFILE_EDUCATION,
  PAGE_MYPROFILE_WORKHISTORY,
  PAGE_MYPROFILE_DOCUMENT,
  PAGE_MYPROFILE_CERTIFICATE,
  EMP_CHECK_LIST_RESIGN_ADMIN,
  PAGE_ASSET_IT,
  PAGE_REPORT,
  PAGE_REPORT_NEW,
  PAGE_REPORT_RESIGN,
  PAGE_REPORT_APPOINT,
  PAGE_REPORT_BIRTHDAY,
  PAGE_ORG_RIGHT,
  PAGE_ORG_RIGHT_DETAIL,
  PAGE_MENU_RIGHT,
  PAGE_ORG_RIGHT_ADD,
  PIM_ORG_EXPAND,
  EMP_CHECK_LIST_DETAIL_ST_2,
  PAGE_INCOME_IN,
  PAGE_INCOME_OUT,
  PAGE_INCOME_KYS,
  PAGE_INCOME_DIF,
  PAGE_INCOME_KYS_DETAIL,
  PAGE_INCOME_DIF_DETAIL,
  PAGE_REPORT_LOAN_HOME,
  PAGE_INCOME_DILIG,
  PAGE_INCOME_SHIFT,
  PAGE_INCOME_SHIFT_DETAIL,
  PAGE_INCOME_DILIG_DETAIL,
  PAGE_SETTING_CERT,
  PAGE_REPORT_ATTENDANCE,
  PAGE_REPORT_LEAVE,
  PAGE_INCOME_CERTIFICATE,
  PAGE_INCOME_CERTIFICATE_DETAIL,
  PAGE_INCOME_PAYROLL,
  PAGE_SETTING_COST_CENTER,
  PAGE_INCOME_PAYROLL_HISTORY,
  PAGE_INCOME_PAYROLL_PRINT,
  PAGE_INCOME_PAYROLL_PRINT_DETAIL,
  PAGE_REPORT_GUSTO,
  PAGE_SETTING_LEAVE,
  PAGE_REPORT_EDUCATION,
  PAGE_SETTING_LOCATION,
  PAGE_SETTING_LOCATION_DETAIL,
  PAGE_SETTING_LOCATION_ASSIGN,
  PAGE_SETTING_NOTI,
  PAGE_SETTING_NOTI_ADD,
  PAGE_SETTING_LEAVE_MAS,
  PAGE_SETTING_LEAVE_ORG,
  PAGE_REPORT_ATTENDANCE_V2,
  PAGE_SETTING_LEAVE_ADD,
  PAGE_SETTING_LEAVE_ASSIGN,
  // PAGE_SETTING_LEAVE_V2,
} from "./router/routes";
import LoginPage from "./pages/login";
import PimNewResignsPage from "./pages/employees/monthly";
import PimCreate from "./pages/employees/pim/AddEmploueesPage";
import EmpPim from "./pages/employees/pim";
import Dashboard from "./pages/dashboard/index";
import OrganizationSetting from "./pages/settings/organization";
import OrgFaction from "./components/setting/org-setting/division";
import OrgDepartment from "./components/setting/org-setting/department";
import OrgTeam from "./components/setting/org-setting/team";
import OrgPosition from "./components/setting/org-setting/position";
import { PageDefault } from "./Constants";
import TrainingPage from "./pages/training";
import EvaluationPage from "./pages/evaluation";
import RecruitmentPage from "./pages/recruitment";
import PDRequestPage from "./pages/pd-request";
import TransferPage from "./pages/employees/transfer";
// import EmpOrganizationChart from './pages/settings/organization-chart'
import PvdPage from "./pages/employees/provident-fund/pvd";
import EjipPage from "./pages/employees/e-jip";
import NewEmplloyePage from "./components/employees/monthly/new-employee";
import HDBReportPage from "./components/employees/monthly/hbd-report";
import ResignsEmplloyeePage from "./components/employees/monthly/resigns-employee";
import AppointEmplloyeePage from "./components/employees/monthly/appoint-employee";
import NotFoundPage from "./pages/not-found";
import StapPage1 from "./components/employees/checklist/new/step-1";
import StapPage2 from "./components/employees/checklist/new/step-2";
import StapPage3 from "./components/employees/checklist/new/step-3";
import StapPage4 from "./components/employees/checklist/new/step-4";

import EjipAllMemberPage from "./components/employees/ejip/e-jip-all-member";

import CheckListPage from "./pages/employees/check-list";
import CheckListNewPage from "./components/employees/checklist/check-list-new";
import CheckListResignsPage from "./components/employees/checklist/check-list-resigns";
import ResignsCheckListIT from "./components/employees/checklist/resigns/it";
import ResignsCheckListPD from "./components/employees/checklist/resigns/pd";
import CheckListDetail from "./components/employees/checklist/index-detail";
// import ContractAllPage from './pages/employees/contract-all-employee'
import ContractNewPage from "./pages/employees/contract";
import EjipDetailPage from "./components/employees/ejip/e-jip-detail";
import AllMemberRoundsPage from "./components/employees/ejip/detail/rounds-all-member";
import IndexDetailContact from "./components/employees/contract/index-detail";
import CompensitionPreview from "./components/employees/contract/contrat-compensition-preview";
import FulltimePreview from "./components/employees/contract/contrat-fulltime-preview";
import PDPAPreview from "./components/employees/contract/contrat-pdpa-preview";
import SecretPreview from "./components/employees/contract/contrat-secret-preview";
// import Index from './components/holiday-setting/holiday'
import HolidayPage from "./pages/settings/holiday";
import TransferHistoryPage from "./components/employees/transfer/history-employee";
import ContractsPage from "./pages/settings/contracts";
import TransferDetailPage from "./components/employees/transfer/detail-history";
import DetailEmployee from "./components/employees/transfer/detail-employee-promote";
import DetailEmployeeOrg from "./components/employees/transfer/detail-employee-org";
import MyProfilePage from "./pages/profile";
import ProfileJopPosition from "./components/my-profile/employee-info/jop-position";
import ProfilePersonalDetails from "./components/my-profile/employee-info/personal-details";
import ProfileEmergencyContact from "./components/my-profile/employee-info/emergency-contact";
import ProfileEducationHistory from "./components/my-profile/employee-info/education-history";
import ProfileWorkHistory from "./components/my-profile/employee-info/work-history";
import ProfileCertificate from "./components/my-profile/employee-info/certificate";
import ProfileDocument from "./components/my-profile/employee-info/document";
import ResignsCheckListAdmin from "./components/employees/checklist/resigns/admin";
import AssetITPage from "./pages/settings/asset-it";
import ReportNewPage from "./components/employees/report/report-new";
import ReportResignPage from "./components/employees/report/report-resign";
import ReportAppointPage from "./components/employees/report/report-appoint";
import ReportBirthdayPage from "./components/employees/report/report-birthday";
import ReportPage from "./pages/report/report";
import AssetOrg from "./pages/settings/org-right";
import AssetOrgDetail from "./components/setting/org-right/AssetOrgDetail";
import MenuRight from "./pages/settings/menu-right/index";
import AssetOrgAdd from "./components/setting/org-right/AssetOrgAdd";
import EmpOrganizationExpand from "./pages/employees/organization-expand";
import StapPage5 from "./components/employees/checklist/new/step-(2)5";
import DetailEmployeePromote from "./components/employees/transfer/detail-employee-promote";
import DetailEmployeeTranOrg from "./components/employees/transfer/detail-employee-org";
import IncomePage from "./pages/income-dif/income";
import DeductionsPage from "./pages/income-dif/deductions";
import HomeLoanPage from "./pages/income-dif/home-loan";
import SLFPage from "./pages/income-dif/slf";
import DetailSLFPage from "./pages/income-dif/slf/DetailSLFPage";
import DetailHomeLoanPage from "./pages/income-dif/home-loan/DetailHomeLoanPage";
import ReportLoanHomePage from "./pages/report/loan-home";
import IncomeDiligenceAllowancePage from "./pages/income-dif/diligence";
import IncomeShiftPage from "./pages/income-dif/shift";
import DetailShiftPage from "./pages/income-dif/shift/DetailShiftPage";
import DetailDiligPage from "./pages/income-dif/diligence/DetailDiligPage";
import SettingCetificatePage from "./pages/settings/cetificate";
import ReportAttendancePage from "./pages/report/attendance";
import ReportLeavePage from "./pages/report/leave";
import CertificateIncomePage from "./pages/income-dif/certificate";
import DetailCertificateIncomePage from "./pages/income-dif/certificate/DetailCertificatePage";
import IncomePayrollPage from "./pages/income-dif/payroll";
import SettingCostCenterPage from "./pages/settings/cost-center";
import HistoryPayrollPage from "./pages/income-dif/payroll/HistoryPayrollPage";
import IncomePayrollPrintPage from "./pages/income-dif/payroll-print";
import DetailIncomePrintPage from "./pages/income-dif/payroll-print/DetailPrintPage";
import GustoReportPage from "./pages/report/gusto";
import LoginLarkPage from "./pages/login-lark";
import ReportEducationPage from "./pages/report/education";
import LocationPage from "./pages/settings/location";
import DetailLocationPage from "./pages/settings/location/page/location.details";
import { EmpPimRoutes } from "./router/emp-pim.routes";
import LocationAssign from "./pages/settings/location/page/location.assign";
import { Toaster } from "sonner";
import NotiCheckInPege from "./pages/settings/noti-check-in-out";
import AddNotiCheckInPege from "./pages/settings/noti-check-in-out/add";
import UseTranslation from "./hooks/use-translate";
import { useTranslation } from "react-i18next";
import SettingLeaveMasterPage from "./pages/settings/leave/component/mastersettingLeave";
import SettingLeaveOrgPage from "./pages/settings/leave/component/orgsettingLeave";
import SettingLeavePage from "./pages/settings/leave";
import ReportAttendanceV1Page from "./pages/report/attendance-v1";
import SettingLeaveV2Page from "./pages/settings/leave/index-v2";
import AddSettingLeavePege from "./pages/settings/leave/component/add";
import AssignSettingLeavePege from "./pages/settings/leave/component/assign";
import { useLanguageStage } from "./store/layout";

function App() {
  const dispatch = useDispatch();
  const menu = useSelector((state) => state.allMenuReducer.allMenu);

  const { languageStage } = useLanguageStage();
  const { data, isLoading } = UseTranslation(languageStage);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (data) {
      i18n.addResourceBundle(languageStage, "translation", data, true, true);
      i18n.changeLanguage(languageStage);
    }
  }, [i18n, languageStage, data]);

  useEffect(() => {
    dispatch(loginActions.restoreLogin());
    dispatch(roleActions.restoreRole());

    return () => {
      dispatch(loginActions.restoreLogin());
      dispatch(roleActions.restoreRole());
    };
  }, [dispatch]);

  if (isLoading) return <div className="preloader-login"></div>;

  return (
    <>
      <Toaster />
      <Routes>
        <Route element={<ProtectedRoutes />}>
          {menu?.allMenu?.length > 0 && (
            <Route
              path={"/"}
              element={
                <Navigate
                  to={
                    menu?.allMenu?.length > 0
                      ? menu?.allMenu[0]?.submenu?.length > 0
                        ? menu?.allMenu[0]?.submenu[0].link
                        : menu?.allMenu[0].link
                      : "/my-profile/job-position"
                  }
                />
              }
            />
          )}

          <Route path={MENU_HOME} element={<Dashboard />} />

          <Route path={PIM_NEW_RESIGN} element={<PimNewResignsPage />}>
            <Route path={EMP_MONTHLY_NEW} element={<NewEmplloyePage />} />
            <Route path={EMP_MONTHLY_HBD} element={<HDBReportPage />} />
            <Route
              path={EMP_MONTHLY_RESIGNS}
              element={<ResignsEmplloyeePage />}
            />
            <Route
              path={EMP_MONTHLY_APPOINT}
              element={<AppointEmplloyeePage />}
            />
          </Route>
          <Route path={PIM_CREATE} element={<PimCreate />} />
          <Route path={PIM_EMP} element={<EmpPim />} />

          <Route element={<TransferPage />}>
            <Route path={EMP_TRANSFER} element={<DetailEmployeePromote />} />
            <Route
              path={EMP_TRANSFER_ORG}
              element={<DetailEmployeeTranOrg />}
            />
          </Route>

          <Route
            path={EMP_TRANSFER_DETAIL_HISTORY}
            element={<TransferDetailPage />}
          />
          <Route path={EMP_TRANSFER_DETAIL} element={<DetailEmployee />} />
          <Route
            path={EMP_TRANSFER_ORG_DETAIL}
            element={<DetailEmployeeOrg />}
          />

          {/* <Route path={PIM_ORG_CHART} element={<EmpOrganizationChart />} /> */}
          <Route path={PIM_ORG_EXPAND} element={<EmpOrganizationExpand />} />
          <Route path={PAGE_ORG_RIGHT} element={<AssetOrg />} />
          <Route path={PAGE_ORG_RIGHT_DETAIL} element={<AssetOrgDetail />} />
          <Route path={PAGE_ORG_RIGHT_ADD} element={<AssetOrgAdd />} />

          <Route path={PAGE_MENU_RIGHT} element={<MenuRight />} />

          <Route path={PIM_TRAIN} element={<TrainingPage />} />
          <Route path={PIM_EVA} element={<EvaluationPage />} />
          <Route path={PIM_RECRUI} element={<RecruitmentPage />} />
          <Route path={PIM_PDREQ} element={<PDRequestPage />} />
          <Route path={PAGE_SETTING} element={<OrganizationSetting />} />
          <Route path={PAGE_HOLIDAY} element={<HolidayPage />} />

          <Route path={PAGE_CONTRACTS} element={<ContractsPage />} />
          <Route path={PAGE_ASSET_IT} element={<AssetITPage />} />

          <Route path={PIM_ORG_FACTION} element={<OrgFaction />} />
          <Route path={PIM_ORG_DEPARTMENT} element={<OrgDepartment />} />
          <Route path={PIM_ORG_TEAM} element={<OrgTeam />} />
          <Route path={PIM_ORG_POSITION} element={<OrgPosition />} />
          <Route element={<CheckListPage />}>
            <Route path={EMP_CHECK_LIST_NEW} element={<CheckListNewPage />} />
            <Route
              path={EMP_CHECK_LIST_RESIGN}
              element={<CheckListResignsPage />}
            />
          </Route>

          <Route
            element={
              <CheckListDetail
                to={EMP_CHECK_LIST_RESIGN}
                title={"Check List Resign Employee"}
              />
            }
          >
            <Route
              index
              path={EMP_CHECK_LIST_RESIGN_IT}
              element={<ResignsCheckListIT />}
            />
            <Route
              index
              path={EMP_CHECK_LIST_RESIGN_ADMIN}
              element={<ResignsCheckListAdmin />}
            />
            <Route
              index
              path={EMP_CHECK_LIST_RESIGN_PD}
              element={<ResignsCheckListPD />}
            />
          </Route>

          <Route
            element={
              <CheckListDetail
                to={EMP_CHECK_LIST_NEW}
                title={"Check List New Employee"}
              />
            }
          >
            <Route
              index
              path={EMP_CHECK_LIST_DETAIL_ST_1}
              element={<StapPage1 />}
            />
            <Route
              index
              path={EMP_CHECK_LIST_DETAIL_ST_2}
              element={<StapPage5 />}
            />
            <Route
              index
              path={EMP_CHECK_LIST_DETAIL_ST_3}
              element={<StapPage2 />}
            />
            <Route
              index
              path={EMP_CHECK_LIST_DETAIL_ST_4}
              element={<StapPage3 />}
            />
            <Route
              index
              path={EMP_CHECK_LIST_DETAIL_ST_5}
              element={<StapPage4 />}
            />
          </Route>

          {/* <Route path={EMP_TRANSFER} element={<ContractAllPage />} /> */}

          {/* <Route path={EMP_CONTRACT_ALL_EMP} element={<ContractAllPage />} /> */}
          <Route path={EMP_CONTRACT_NEW_EMP} element={<ContractNewPage />} />
          <Route element={<IndexDetailContact />}>
            <Route
              path={EMP_CONTRACT_FULLTIME_PDF}
              element={<FulltimePreview />}
            />
            <Route path={EMP_CONTRACT_SECRET_PDF} element={<SecretPreview />} />
            <Route path={EMP_CONTRACT_PDPA_PDF} element={<PDPAPreview />} />
            <Route
              path={EMP_CONTRACT_COMPENSATION_SLIP_PDF}
              element={<CompensitionPreview />}
            />
          </Route>
          {/* TransferPage */}
          <Route path={EMP_PVD} element={<PvdPage />} />
          <Route path={EMP_PVD_HISTORY} element={<TransferHistoryPage />} />
          {/* <Route path={EMP_PVD} element={<PvdPage />} /> */}
          <Route path={EMP_EJIP} element={<EjipPage />} />
          <Route path={EMP_EJIP_DETAIL} element={<EjipDetailPage />} />

          <Route path={EMP_EJIP_ALLMEMBER} element={<EjipAllMemberPage />} />
          <Route
            path={EMP_EJIP_MEMBERBY_ROUND}
            element={<AllMemberRoundsPage />}
          />

          {/* <Route element={<PimEmployeeDetail />}>
            <Route element={<EmployeeInfo />}>
              <Route path={PIM_EMP_INFO} element={<JopPosition />} />
              <Route path={INFO_HIST} element={<HistoricalData />} />
              <Route path={INFO_PERSONAL} element={<PersonalDetails />} />
              <Route path={INFO_EMER} element={<EmergencyContact />} />
              <Route path={INFO_EDUC} element={<EducationHistory />} />
              <Route path={INFO_WORK} element={<WorkHistory />} />
              <Route path={INFO_CRIMINAL} element={<CriminalRecord />} />
              <Route path={INFO_DOCUMENT} element={<Document />} />
              <Route path={INFO_CERTIFICATE} element={<Certificate />} />
              <Route
                path={INFO_RESIGNS}
                element={<InfoResignsEmployeePage />}
              />
            </Route>

            <Route path={PIM_EMP_WELFARE} element={<EmpWelfare />} />
            <Route path={PIM_EMP_WELFARE_EJIP} element={<EmpWelfareEJIP />} />
            <Route path={PIM_EMP_WELFARE_PVD} element={<EmpWelfarePVD />} />
            <Route path={PIM_EMP_WELFARE_BEM} element={<EmpWelfareBEM />} />
            <Route path={PIM_EMP_WELFARE_CAR} element={<EmpWelfareCar />} />
            <Route
              path={PIM_EMP_WELFARE_LOAN_HOME}
              element={<EmpWelfareLoanHomePage />}
            />
            <Route
              path={PIM_EMP_WELFARE_CAR_PARK}
              element={<EmpWelfareCarPark />}
            />
            <Route
              path={PIM_EMP_WELFARE_FIT_FIRM}
              element={<EmpWelfareFitFirm />}
            />
            <Route path={PIM_EMP_WELFARE_LEAVE} element={<EmpWelfareLeave />} />

            <Route path={PIM_EMP_PROPERTY} element={<PropertyInfo />} />
            <Route path={PIM_EMP_PROPERTY_ASS} element={<PropertyInfoASS />} />
            <Route
              path={PIM_EMP_PERSONAL_PROFILE}
              element={<PersonalProfile />}
            />
          </Route> */}

          {EmpPimRoutes}

          <Route path={PAGE_REPORT} element={<ReportPage />} />
          <Route path={PAGE_REPORT_NEW} element={<ReportNewPage />} />
          <Route path={PAGE_REPORT_RESIGN} element={<ReportResignPage />} />
          <Route path={PAGE_REPORT_APPOINT} element={<ReportAppointPage />} />
          <Route path={PAGE_REPORT_BIRTHDAY} element={<ReportBirthdayPage />} />
          <Route path={PAGE_REPORT_GUSTO} element={<GustoReportPage />} />

          <Route
            path={PAGE_REPORT_ATTENDANCE}
            element={<ReportAttendanceV1Page />}
          />
          <Route
            path={PAGE_REPORT_ATTENDANCE_V2}
            element={<ReportAttendancePage />}
          />
          <Route path={PAGE_REPORT_LEAVE} element={<ReportLeavePage />} />
          <Route
            path={PAGE_REPORT_LOAN_HOME}
            element={<ReportLoanHomePage />}
          />

          <Route
            path={PAGE_REPORT_EDUCATION}
            element={<ReportEducationPage />}
          />

          <Route element={<MyProfilePage />}>
            <Route
              path={"/my-profile"}
              element={<Navigate to={PAGE_MYPROFILE} />}
            />
            <Route path={PAGE_MYPROFILE} element={<ProfileJopPosition />} />
            <Route
              path={PAGE_MYPROFILE_PRESONAL}
              element={<ProfilePersonalDetails />}
            />
            <Route
              path={PAGE_MYPROFILE_EMERGENCY}
              element={<ProfileEmergencyContact />}
            />
            <Route
              path={PAGE_MYPROFILE_EDUCATION}
              element={<ProfileEducationHistory />}
            />
            <Route
              path={PAGE_MYPROFILE_WORKHISTORY}
              element={<ProfileWorkHistory />}
            />
            <Route
              path={PAGE_MYPROFILE_DOCUMENT}
              element={<ProfileDocument />}
            />
            <Route
              path={PAGE_MYPROFILE_CERTIFICATE}
              element={<ProfileCertificate />}
            />
          </Route>

          <Route path={PAGE_INCOME_IN} element={<IncomePage />} />
          {/* <Route path={PAGE_INCOME_IN_NEW} element={<NewImportIncomePage />} /> */}
          <Route path={PAGE_INCOME_OUT} element={<DeductionsPage />} />
          <Route path={PAGE_INCOME_KYS} element={<SLFPage />} />
          <Route path={PAGE_INCOME_KYS_DETAIL} element={<DetailSLFPage />} />
          <Route path={PAGE_INCOME_DIF} element={<HomeLoanPage />} />
          <Route
            path={PAGE_INCOME_DIF_DETAIL}
            element={<DetailHomeLoanPage />}
          />

          <Route
            path={PAGE_INCOME_DILIG}
            element={<IncomeDiligenceAllowancePage />}
          />
          <Route
            path={PAGE_INCOME_DILIG_DETAIL}
            element={<DetailDiligPage />}
          />

          <Route path={PAGE_INCOME_SHIFT} element={<IncomeShiftPage />} />

          <Route
            path={PAGE_INCOME_SHIFT_DETAIL}
            element={<DetailShiftPage />}
          />

          <Route path={PAGE_SETTING_CERT} element={<SettingCetificatePage />} />

          <Route
            path={PAGE_INCOME_CERTIFICATE}
            element={<CertificateIncomePage />}
          />
          <Route
            path={PAGE_INCOME_CERTIFICATE_DETAIL}
            element={<DetailCertificateIncomePage />}
          />
          <Route path={PAGE_INCOME_PAYROLL} element={<IncomePayrollPage />} />

          <Route
            path={PAGE_INCOME_PAYROLL_PRINT}
            element={<IncomePayrollPrintPage />}
          />

          <Route
            path={PAGE_INCOME_PAYROLL_PRINT_DETAIL}
            element={<DetailIncomePrintPage />}
          />

          <Route
            path={PAGE_INCOME_PAYROLL_HISTORY}
            element={<HistoryPayrollPage />}
          />
          <Route
            path={PAGE_SETTING_COST_CENTER}
            element={<SettingCostCenterPage />}
          />

          <Route path={PAGE_SETTING_LEAVE} element={<SettingLeaveV2Page />}>
            <Route
              path={PAGE_SETTING_LEAVE_MAS}
              element={<SettingLeaveMasterPage />}
            />
            <Route
              path={PAGE_SETTING_LEAVE_ORG}
              element={<SettingLeaveOrgPage />}
            />
          </Route>
          <Route
            path={PAGE_SETTING_LEAVE_ADD}
            element={<AddSettingLeavePege />}
          />
          <Route
            path={PAGE_SETTING_LEAVE_ASSIGN}
            element={<AssignSettingLeavePege />}
          />
          {/* <Route path={PAGE_SETTING_LEAVE} element={<SettingLeavePage />} /> */}

          <Route path={PAGE_SETTING_LOCATION} element={<LocationPage />} />
          <Route
            path={PAGE_SETTING_LOCATION_DETAIL}
            element={<DetailLocationPage />}
          />
          <Route
            path={PAGE_SETTING_LOCATION_ASSIGN}
            element={<LocationAssign />}
          />
          <Route path={PAGE_SETTING_NOTI} element={<NotiCheckInPege />} />
          <Route
            path={PAGE_SETTING_NOTI_ADD}
            element={<AddNotiCheckInPege />}
          />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
        {/* Public user */}
        <Route element={<PublicRoutes />}>
          <Route path={`/login-lark/:appId`} element={<LoginLarkPage />} />
          <Route path={MENU_LOGIN} element={<LoginPage />} />
          <Route path="*" element={<NotFoundPage />} />
          <Route path={PageDefault} element={<Navigate to={MENU_LOGIN} />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
